var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateReducer, } from "../generators/generator.reducer";
import { getInsuranceStart, getInsuranceSucceeded, getInsuranceFailed, 
// resendInsuranceInviteExternalStart,
// resendInsuranceInviteExternalSucceeded,
// resendInsuranceInviteExternalFailed,
// pollInsuranceStatusExternalStart,
// pollInsuranceStatusExternalSucceeded,
// pollInsuranceStatusExternalFailed,
// resetInsuranceProposalStart,
// resetInsuranceProposalSucceeded,
// resetInsuranceProposalFailed,
getInsuranceForContractStart, getInsuranceForContractSucceeded, getInsuranceForContractFailed, } from "./insurance.actions";
import { GENERATOR_PARAMS } from "./insurance.constants";
var getExtraDefaultState = function () { return ({
    insurances: {},
    insurancesForContracts: {},
}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
var reducer = _reducer;
reducer.on(getInsuranceStart.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { insurances: __assign(__assign({}, state.insurances), (_a = {}, _a[payload.id] = {
            isFetching: true,
            fetchError: undefined,
        }, _a)) });
});
reducer.on(getInsuranceSucceeded.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { insurances: __assign(__assign({}, state.insurances), (_a = {}, _a[payload.data.id] = {
            insurance: payload.data,
            isFetching: false,
            fetchError: undefined,
        }, _a)) });
});
reducer.on(getInsuranceFailed.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { insurances: __assign(__assign({}, state.insurances), (_a = {}, _a[payload.id] = {
            isFetching: false,
            fetchError: payload.error,
        }, _a)) });
});
reducer.on(getInsuranceForContractStart.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { insurancesForContracts: __assign(__assign({}, state.insurancesForContracts), (_a = {}, _a[payload.contractId] = {
            isFetching: true,
            fetchError: undefined,
        }, _a)) });
});
reducer.on(getInsuranceForContractSucceeded.type, function (state, payload) {
    var _a, _b;
    return __assign(__assign({}, state), { insurances: __assign(__assign({}, state.insurances), (_a = {}, _a[payload.data.id] = {
            insurance: payload.data,
        }, _a)), insurancesForContracts: __assign(__assign({}, state.insurancesForContracts), (_b = {}, _b[payload.contractId] = {
            isFetching: false,
            fetchError: undefined,
        }, _b)) });
});
reducer.on(getInsuranceForContractFailed.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { insurances: __assign(__assign({}, state.insurances), (_a = {}, _a[payload.contractId] = {
            isFetching: false,
            fetchError: payload.error,
        }, _a)) });
});
// reducer.on<typeof getInsuranceStart.payloadType>(
//   getInsuranceStart.type,
//   (state, payload) => {
//     return {
//       ...state,
//       insurances: {
//         ...state.insurances,
//         [payload.id]: {
//           isFetching: true,
//           fetchError: undefined,
//         },
//       },
//     };
//   },
// );
// reducer.on<typeof getInsuranceSucceeded.payloadType>(
//   getInsuranceSucceeded.type,
//   (state, payload) => {
//     return {
//       ...state,
//       insurances: {
//         ...state.insurances,
//         [payload.data.id]: {
//           insurance: payload.data,
//           isFetching: false,
//           fetchError: undefined,
//         },
//       },
//     };
//   },
// );
// reducer.on<typeof getInsuranceFailed.payloadType>(
//   getInsuranceFailed.type,
//   (state, payload) => {
//     return {
//       ...state,
//       insurances: {
//         ...state.insurances,
//         [payload.id]: {
//           isFetching: false,
//           fetchError: payload.error,
//         },
//       },
//     };
//   },
// );
// eslint-disable-next-line import/no-default-export
export default reducer;
